<template>
  <div
    class="marketing-content"
    :class="{'marketing-content--loaded': story && !story.hidden && display}"
  >
    <div class="marketing-content__bg" />
    <div
      v-if="story"
      class="marketing-content__wrap"
    >
      <h3
        v-if="story.title"
        class="marketing-content__title"
      >
        {{ story.title }}
      </h3>
      <img
        v-if="story.image && story.image.filename"
        width="500"
        height="347"
        alt=""
        :src="`${story.image.filename}/m/fit-in/1000x694/filters:format(webm):quality(90)`"
        class="marketing-content__picture"
      >
      <div class="marketing-content__text">
        <p v-if="story.firstParagraph">
          {{ story.firstParagraph }}
        </p>
        <ul>
          <li v-if="story.bullet1">
            {{ story.bullet1 }}
          </li>
          <li v-if="story.bullet2">
            {{ story.bullet2 }}
          </li>
          <li v-if="story.bullet3">
            {{ story.bullet3 }}
          </li>
        </ul>
        <p v-if="story.secondParagraph">
          {{ story.secondParagraph }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    display: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      story: false,
    };
  },
  async created() {
    const version = process.env.STORYBLOK_VERSION || 'published';
    const response = await axios.get(`https://api.storyblok.com/v2/cdn/stories/launchpad?version=${version}&token=yuo9pU1v4JBrDhbERXWmTwtt`);
    this.story = response.data.story.content;
  },
};
</script>

<style lang="scss" scoped>
.marketing-content {
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-family: "Work Sans";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: fit-content;
  padding: 50px 37px;

  @media (min-height: 850px) {
    margin-top: -50px;
    height: 100%;
    padding: 0 37px;
  }

  &--loaded {
    display: flex;
  }

  &__bg {
    position: absolute;
    inset: -10%;
    z-index: -1;
    background-image:
      radial-gradient(
        circle at 30% 125%,
        #ff97da 35%,
        transparent 0
      ),
      radial-gradient(
        circle at 130% 15%,
        #d5c8fb 35%,
        transparent 0
      );
    background-position: 100% 0;
    background-repeat: no-repeat;
    background-size: 100%;
    content: "";
    filter: blur(200px);
  }

  &__wrap {
    display: flex;
    flex-direction: column;
    max-width: 500px;
    gap: 16px;
  }

  &__title {
    font-weight: 700;
    font-size: 24px;
    line-height: 115%;
    letter-spacing: 0;
    color: inherit;
    text-wrap: balance;
  }

  &__picture {
    display: block;
    width: 100%;
    height: auto;
    max-width: 500px;
    border-radius: 7.65px;
  }

  &__text :is(p, li){
    margin: 6px 0;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.75px;
    line-height: 145%;
    color: #FCFCFC;
  }

  &__text :is(ul){
    margin: 10px 0 20px 0;
    padding-inline-start: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// MarketingContent.vue?508720de